import React from "react";
import { COMPANY } from "@/i18n/translations";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton({ prefill = "" }) {
  const href = `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(
    prefill || "Hallo DNA Automotive, ich interessiere mich für ein Fahrzeug."
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp Kontakt"
      data-testid="whatsapp-float-button"
      className="group fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-brand text-black font-bold px-5 py-4 rounded-full shadow-[0_0_30px_rgba(46,224,107,0.4)] hover:bg-brand-hover hover:scale-105 transition-all duration-300"
    >
      <span className="absolute inset-0 rounded-full bg-brand/50 animate-ping [animation-duration:3s] group-hover:[animation-play-state:paused] -z-10" aria-hidden="true" />
      <MessageCircle className="w-5 h-5" strokeWidth={2.5} />
      <span className="hidden sm:inline text-sm uppercase tracking-wider">WhatsApp</span>
    </a>
  );
}
